(function (appName) {
    RCDPW.Angular.setAppName(appName);
    var routes = {
        gettingStarted: {
            path: '/console/hello-world?source=menu',
            href: '/console/hello-world',
            menuType: 'accountInfo',
            hideHelpLink: true,
            noTitle: true,
            navText: 'Getting Started',
            external: true
        },
        appsList: {
            controller: 'appsListCtrl',
            path: '/applications',
            templateUrl: 'myAccount-applications.html',
            logPageViewTitle: 'Applications',
            menuType: 'accountInfo',
            navText: 'Apps',
            noTitle: true,
            hideBreadCrumb: true
        },

        appDashboard: {
            controller: 'appDashboardCtrl',
            path: '/application-dashboard/:id',
            templateUrl: 'application-dashboard.html',
            navText: 'Dashboard',
            menuType: 'application',
            logPageViewTitle: 'AppDashboard'
        },
        appSettings: {
            href: '/console/application/:id/settings',
            path: '/console/application/:id/settings',
            navText: 'Settings',
            menuType: 'application',
            external: true
        },
        appCredentials: {
            href: '/console/application/:id/credentials',
            path: '/console/application/:id/credentials',
            navText: 'Credentials',
            menuType: 'application',
            external: true
        },
        appGraduation: {
            href: '/console/application/:id/graduation',
            path: '/console/application/:id/graduation',
            navText: 'Graduation',
            menuType: 'application',
            external: true
        },
        reports: {
            controller: 'reportsCtrl',
            path: '/application/:id/reports',
            templateUrl: 'application-reports.html',
            navText: 'Analytics',
            menuType: 'application',
            logPageViewTitle: 'Application Reports',
            reloadOnSearch: false
        },
        appApiCallHistory: {
            href: '/console/application/:id/api-call-history',
            path: '/console/application/:id/api-call-history',
            navText: 'API history',
            menuType: 'application',
            external: true
        },
        createApp: {
            controller: 'createAppCtrl',
            path: '/create-app',
            templateUrl: 'myAccount-applications.html',
            noNav: true,
            noTitle: true
        },
        leadsReport: {
            controller: 'leadsReportCtrl',
            path: '/leads-report',
            template: '<dpw-leads-report></dpw-leads-report>',
            navText: 'Leads Report',
            menuType: 'accountInfo',
            logPageViewTitle: 'LeadsReport',
            hideBreadCrumb: true
        },
        myProfile: {
            controller: 'myProfileCtrl',
            path: '/my-profile',
            logPageViewTitle: 'Profile',
            menuType: 'userProfile',
            hideHelpLink: true,
            noTitle: true,
            navText: 'User Profile'
        },
        myCredentials: {
            path: '/console/my-credentials',
            href: '/console/my-credentials',
            menuType: 'userProfile',
            hideHelpLink: true,
            noTitle: true,
            navText: 'Credentials',
            external: true
        },
        developerCredentials: {
            path: '/console/user/:id/credentials',
            href: '/console/user/:id/credentials',
            menuType: 'userProfile',
            hideHelpLink: true,
            noTitle: true,
            navText: 'Credentials',
            external: true
        },
        org: {
            controller: 'orgCtrl',
            path: '/my-organization',
            logPageViewTitle: 'OrganizationInfo',
            menuName: 'Organization',
            menuType: 'accountInfo',
            navText: 'Organization',
            noTitle: true,
            hideBreadCrumb: true
        },
        developerProfile: {
            controller: 'developerProfileCtrl',
            path: '/developer-profile/:id',
            templateUrl: 'myAccount-my-profile.html',
            logPageViewTitle: 'Profile',
            belongTo: 'myProfile',
            noTitle: true,
            noActivatedTopMenu: true,
            hideHelpLink: true
        },
        developerProfileNav: {
            controller: 'developerProfileCtrl',
            path: '/developer-profile/:id',
            templateUrl: 'myAccount-my-profile.html',
            logPageViewTitle: 'Profile',
            noTitle: true,
            hideHelpLink: true,
            belongTo: 'developerProfileNav',
            menuType: 'userProfile',
            navText: 'User Profile'
        },
        editProfile: {
            controller: 'editProfileCtrl',
            path: '/edit-profile',
            logPageViewTitle: 'EditProfile',
            belongTo: 'myProfile',
            noTitle: true,
            noActivatedTopMenu: true,
            hideHelpLink: true
        },
        appUsagePlanDetails: {
            controller: 'appUsagePlanDetailsCtrl',
            path: '/app-usage-plan-details/:id',
            templateUrl: 'myAccount-app-usage-plan-details.html',
            navText: 'Rate limits',
            menuType: 'application',
            logPageViewTitle: 'AppRateLimits'
        },
        appStatusAndReview: {
            controller: 'appStatusAndReviewCtrl',
            path: '/status-and-review/:id',
            template: '',
            navText: 'Status & Review',
            menuType: 'application',
            logPageViewTitle: 'appStatusAndReview'
        },
        appPromote: {
            href: '/console/application/:id/promote',
            path: '/console/application/:id/promote',
            navText: 'App Gallery',
            menuType: 'application',
            external: true
        },
        appPublish: {
            controller: 'appPublishCtrl',
            path: '/applications/:id/publish/:appProfileId?',
            belongTo: 'appPromote',
            templateUrl: 'myAccount-app-publish.html',
            navText: 'Publish',
            menuType: 'application',
            autoScroll: false,
            logPageViewTitle: 'appPublish',
            reloadOnSearch: false
        },
        apiQuickStart: {
            controller: 'apiQuickStartCtrl',
            path: '/getting-started/api-quick-start',
            template: '<div />',
            noTitle: true,
            navText: 'API Quick Start',
            menuType: 'accountInfo',
            logPageViewTitle: 'ApiQuickStart',
            hideBreadCrumb: true
        },
        setupWizard: {
            controller: 'setupWizardCtrl',
            path: '/getting-started/setup-wizard',
            template: '<div />',
            noTitle: true,
            navText: 'Setup Wizard',
            menuType: 'accountInfo',
            logPageViewTitle: 'SetupWizard',
            hideBreadCrumb: true
        },
        appCreated: {
            controller: 'appCreatedCtrl',
            path: '/app-created',
            templateUrl: 'myAccount-applications.html',
            noNav: true,
            noTitle: true
        }
    };

    RCDPW.Angular.buildModule('services')
        .factory('appInfo', [
            'api', 'helpers', '$q', 'accessLevels', '$timeout', 'applicationService',
            function (api, helpers, $q, accessLevels, $timeout, applicationService) {
                var refreshCount;
                return {
                    fetch: function (options) {
                        refreshCount = 0;
                        doFetch(options);
                        return function (additionalOptions) { //For refresh purpose
                            doFetch(_.assign({}, options, additionalOptions));
                        };
                    }
                };

                function doFetch(options) {
                    var info = {
                        application: {},
                        appKeys: {},
                        enableEditApp: null,
                        grantTypes: [],
                        permissions: [],
                        grantTypesMap: {},
                        permissionsMap: {},
                        brandId: null,
                        hasProductionReport: false
                    };
                    var scope = options.scope;
                    var callback = options.callback || function () {
                    };
                    var appId = options.id;
                    var simple = options.simple !== false;
                    info.appKeys = [];
                    info.enableEditApp = true;
                    info.enableEditRedirectURI = true;
                    api.call(api.myAccount.applications.detail({
                        applicationId: appId,
                        simple: simple,
                        noLoading: options.noLoading
                    }), function (data) {
                        info.application = applicationService.parseApp(data.application);
                        info.application.shortDescription = data.shortDescription;
                        info.appKeys = data.appKeys || [];
                        info.enableEditApp = helpers.appStateUtil.isInDev(info.application);
                        info.enableEditRedirectURI = helpers.appStateUtil.canEditRedirectURI(info.application);
                        info.grantTypes = data.grantTypes;
                        angular.forEach(info.grantTypes, function (item) {
                            info.grantTypesMap[item.id] = item;
                        });
                        info.permissions = data.permissions;
                        info.hasProductionReport = data.hasProductionReport;
                        angular.forEach(info.permissions, function (item) {
                            info.permissionsMap[item.id] = item;
                        });
                        handleDataWithAccessLevel();
                        info.brandId = data.brandId;
                        _.extend(scope, angular.copy(info));
                        options.installCredentials && installCredentials();
                        callback();

                        function installCredentials() {
                            var ctrl = options.ctrlObj;
                            var refreshInterval = 5000; //ms
                            ctrl.prodKeys = _.filter(scope.appKeys, function (key) {
                                return key.isProduction;
                            });
                            ctrl.selectedProdKey = _.first(ctrl.prodKeys);

                            ctrl.brandId = scope.brandId;
                        }

                        function handleDataWithAccessLevel() {
                            var accessLevelsOrder = {};
                            _.forEach(accessLevels, function (item, idx) {
                                accessLevelsOrder[item] = idx;
                            });

                            _.forEach(['permissions', 'grantTypes'], filterWithAccessLevel);

                            function filterWithAccessLevel(keyName) {
                                _.remove(info[keyName], function (item) {
                                    var belongToHigherLevel = (accessLevelsOrder[item.accessLevel] > accessLevelsOrder[info.application.organization.accessLevel]);
                                    var isAdditional = (info.application.id ? (info.application[keyName].indexOf(item.id) >= 0) : false);
                                    return belongToHigherLevel && (!isAdditional);
                                });
                            }
                        }
                    });
                }
            }
        ])
        .factory('myAccountNav', ['$q', '$rootScope', '$location', '$route', 'helpers', 'appProfileUtils',
            'dpwAccessService', 'dpwLeadsReportService', 'applicationService', 'organizationService',
            function ($q, $rootScope, $location, $route, helpers, appProfileUtils,
                dpwAccessService, dpwLeadsReportService, applicationService, organizationService) {

                var accountInfoGroup = {
                    items: [
                        routes.gettingStarted,
                        routes.appsList,
                        routes.org,
                    ].map(function (item) {
                        return groupItemConstructor(item);
                    })
                };

                var accountInfoGroups = [accountInfoGroup];

                organizationService.isQuickStartFlowEnabled().then(function (enabled) {
                    if (enabled) {
                        dpwAccessService.canGetStarted()
                            .then(angular.noop)
                            .catch(function () {
                                accountInfoGroup.items.shift();
                            });
                    } else {
                        accountInfoGroup.items.shift();
                    }
                });

                $q.all([
                    dpwLeadsReportService.isVisible(),
                ]).then(function (res) {
                    var leadsReportVisible = res[0];
                    if (leadsReportVisible) {
                        accountInfoGroup.items.push(groupItemConstructor(routes.leadsReport));
                        if ($route.current.path === routes.leadsReport.path) {
                            routes.leadsReport.active = true;
                        }
                    }
                });

                var menuTypes = {
                    accountInfo: function () {
                        return accountInfoGroups;
                    },
                    userProfile: function (options) {
                        var id = _.get(options, 'routeParams.id');
                        var credentials = id ? routes.developerCredentials : routes.myCredentials;
                        var profile = id ? routes.developerProfileNav : routes.myProfile;

                        var groupItemBuilder = function (item) {
                            return groupItemConstructor(item, id ? { hrefId: id } : undefined);
                        };

                        var menuGroup = {
                            items: [profile].map(groupItemBuilder)
                        };

                        resolveCredentialsItem();

                        return [menuGroup];

                        function resolveCredentialsItem() {
                            var actionForCurrentUser = id
                                ? dpwAccessService.UserAction.VIEW_API_CREDENTIALS_FOR_ANY_USER
                                : dpwAccessService.UserAction.VIEW_MY_API_CREDENTIALS;

                            var promise = dpwAccessService.currentUserCan(
                                actionForCurrentUser
                            );

                            if (id) {
                                promise = promise.then(function () {
                                    return dpwAccessService.targetUserCan(
                                        id,
                                        dpwAccessService.UserAction.VIEW_MY_API_CREDENTIALS
                                    );
                                });
                            }

                            promise.then(function () {
                                menuGroup.items.push(groupItemBuilder(credentials));
                            });
                        }
                    },
                    application: function (options) {
                        var NAV_ITEMS_KEYS = [
                            'appDashboard',
                            'appSettings',
                            'appPromote',
                            'appUsagePlanDetails',
                            'reports'
                        ];

                        options = options || {};
                        var application = options.application || {};

                        if (!appProfileUtils.isAppPublishEnabled(application)) {
                            removeNavItem(NAV_ITEMS_KEYS, 'appPromote');
                        }

                        if (applicationService.isNotificationApp(application)) {
                            removeNavItem(NAV_ITEMS_KEYS, 'appUsagePlanDetails');
                            removeNavItem(NAV_ITEMS_KEYS, 'reports');
                        }

                        if (applicationService.isProfileOnly(application)) {
                            NAV_ITEMS_KEYS = ['appSettings', 'appPromote'];
                        }

                        if (options.isApiCallHistoryEnabled) {
                            NAV_ITEMS_KEYS.push('appApiCallHistory');
                        }

                        var appGraduationIcon = function () {
                            var applicationStatus = helpers.appStateUtil.getStatus(application);
                            var tooltips = {
                                blocked: 'Your app had been blocked in production',
                                declined: 'Your graduation request had been declined'
                            };
                            var displayIcon = _.includes(['Blocked', 'Declined'], applicationStatus);

                            return displayIcon ? {
                                name: 'icon-icon_triangle_exclamation',
                                extraClass: 'dpw-left-panel-nav-item-warn',
                                tooltip: tooltips[applicationStatus.toLowerCase()]
                            } : null;
                        };

                        var iconMappings = {
                            'appGraduation': appGraduationIcon,
                            'appApplyForProd': appGraduationIcon
                        };

                        var applicationMenuGroup = {
                            items: NAV_ITEMS_KEYS.map(function (key) {
                                var route = routes[key];
                                var getIcon = iconMappings[key];

                                addNavHref(route, _.get(application, 'id', ''));

                                route.iconTail = _.isFunction(getIcon) && getIcon();
                                route.routeId = key;

                                if (route.navText) {
                                    route.label = route.navText;
                                }

                                return route;
                            })
                        };

                        return options.application ? [applicationMenuGroup] : [];

                        function removeNavItem(navItems, itemToRemove) {
                            if (!_.isArray(navItems)) {
                                return;
                            }
                            var index = navItems.indexOf(itemToRemove);
                            if (index !== -1) {
                                navItems.splice(index, 1);
                            }
                        }
                    }
                };

                var myAccountNav = {
                    /**
                     * Get groups for #{menuType}.
                     *
                     * @param {String} menuType     - Menu Type.
                     * @param {Object} [options]    - Extra arguments.
                     * @returns {Array} Groups
                     */
                    get: function (menuType, options) {
                        var menuGroupsResolver = menuTypes[menuType];
                        if (_.isFunction(menuGroupsResolver)) {
                            return menuGroupsResolver(options);
                        }
                    },

                    /**
                     * Activate {#route}.
                     *
                     * @param {Object} route
                     * @param {Array} groups
                     *
                     * Preferentially activate the item which {#route} belongs to.
                     * Fallback to {#route} itself when:
                     *   1. {#route}.belongTo is undefined.
                     *   2. {#route}.belongTo is not defined in `routes`
                     *
                     * @param route
                     */
                    active: function (route, groups) {
                        route = routes[route.belongTo] || route;

                        Array.isArray(groups) && groups.forEach(function (group) {
                            group.items.forEach(function (item) {
                                item.active = (route.path === item.path);
                            });
                        });
                    },

                    /**
                     *
                     * @param route
                     * @param [options]
                     */
                    resolve: function (route, options) {
                        route = route.belongTo ? routes[route.belongTo] : route;
                        var groups = this.get(route.menuType, options);
                        this.active(route, groups);

                        return groups;
                    },
                    redirectToDashboard: function (appId) {
                        $location.path(routes.appDashboard.path.replace(':id', appId));
                    },
                    redirectToSettingsIfNeeded: function (application) {
                        if (applicationService.isProfileOnly(application)) {
                            window.location.href = '/console/application/' + application.id + '/settings';
                            return true;
                        }
                        return false;
                    }
                };

                function groupItemConstructor(item, options) {
                    var hrefId = _.get(options, 'hrefId');
                    addNavHref(item, hrefId);
                    if (item.navText) {
                        item.label = item.navText;
                    }
                    return item;
                }

                /**
                 * Add `navHref` property to nav items.
                 *
                 * @param {Object} route    - Nav item.
                 * @param {String} [id]       - Replace the `:id` placeholder in #{route}.
                 */
                function addNavHref(route, id) {
                    var rawPath = route.path;
                    var path = id ? rawPath.replace(':id', id) : rawPath;

                    if (route.external) {
                        route.href = path;
                    } else {
                        route.href = route.navHref = '/my-account.html#' + path;
                    }

                    return route.href;
                }

                return myAccountNav;
            }])
        .factory('botErrorHandler', ['$q', 'user', 'brandService', 'helpers', 'botEnvKeys',
            function ($q, user, brandService, helpers, botEnvKeys) {
                var prodKey = botEnvKeys.PROD;

                var staticMsgDic = {
                    'NO_INSTALL_PERMISSION': 'You currently don\'t have the necessary "Add Bots" permission. Please contact your system administrator.',
                    'NO_UNINSTALL_PERMISSION': 'You currently don\'t have the necessary "Remove Bots" permission. Please contact your system administrator.',
                    'HIPAA_COMPLIANCE_ACCOUNT': 'Bot support for HIPAA Customer is coming soon!',
                    'FREE_TIER': '<a href="https://www.ringcentral.com/office/plansandpricing.html" target="_blank">Upgrade your account</a> to RingCentral MVP™ Premium or Ultimate to deploy your app in production.',
                    'BOT_CALL_REDIRECT_URI_FAIL': 'We are unable to install the bot to the account. The redirect URL returned an unsuccessful response.',
                    'BOT_SUBSCRIBE_WEB_HOOK_FAIL': 'We are unable to install the bot to the account since subscription is failed.',
                    'NOT_ACTIVE_APP': 'We are unable to install the bot to the account. Bot can only be installed if the Application status is active.',
                    'BOT_ALREADY_INSTALLED': 'This add-in is already installed in your account.',
                };

                var dynamicMsgHandlers = {
                    'BOT_EXT_NOT_EXIST': handleBotNotExisted,
                    'BOT_BRAND_NOT_SUPPORTED': handleNotSupportedBrand,
                    'NO_REDIRECT_URI': handleNoRedirectUri
                };

                var pageMsgHandlers = {
                    'NO_VALID_APP_BRAND': handleNoValidAppBrand,
                };

                return {
                    popupMsg: function (errorType, scope, ctrl, env, callback) {
                        if (staticMsgDic[errorType]) {
                            popupErrorMsg(staticMsgDic[errorType]);
                            callback && callback();
                            return;
                        }

                        if (dynamicMsgHandlers[errorType]) {
                            dynamicMsgHandlers[errorType](ctrl, env, scope);
                            callback && callback();
                            return;
                        }
                    },
                    showMsgInPage: function (errorType, ctrl, env) {
                        var actionKey = 'actionEnabledInProd';
                        var disabledMsgKey = 'disabledMsgInProd';

                        if (staticMsgDic[errorType]) {
                            handleGeneralError(actionKey, disabledMsgKey, ctrl, errorType);
                            return;
                        }

                        if (pageMsgHandlers[errorType]) {
                            pageMsgHandlers[errorType](actionKey, disabledMsgKey, ctrl, env);
                            return;
                        }
                    },
                    getBrandId: getBrandId
                };

                function handleBotNotExisted(ctrl, env) {
                    var msg = '@' + ctrl.botInfo[env].name + ' has already been uninstalled from your account.';
                    popupErrorMsg(msg, true);
                }

                function handleNotSupportedBrand(env) {
                    $q.all([user.fetch(), brandService.fetchBrands()]).then(function () {
                        var message = getNotSupportedBrandMsg(user.getUser(), brandService.getBrandMap(), env);
                        RCDPW.modal && RCDPW.modal.create().content(message).show();
                    });
                }

                function handleNoRedirectUri(ctrl, env, scope) {
                    var appSettingsUrl = helpers.buildAngularAppUrl(ctrl.application.id, 'settings');
                    var message = 'A valid redirect URL is required before generating the access token! ' +
                        'You can update it in <a href="' + appSettingsUrl + '">setting page</a> and retry.';
                    popupErrorMsg(message);
                }

                function handleGeneralError(actionKey, msgKey, ctrl, type) {
                    ctrl[actionKey] = false;
                    ctrl[msgKey] = staticMsgDic[type];
                }

                function handleNoValidAppBrand(actionKey, msgKey, ctrl, env) {
                    ctrl[actionKey] = false;

                    $q.all([user.fetch(), brandService.fetchBrands()]).then(function () {
                        ctrl[msgKey] = getNotSupportedBrandMsg(user.getUser(), brandService.getBrandMap(), env);
                    });
                }

                function getNotSupportedBrandMsg(userInfo, brandMap, env) {
                    var brandId = getBrandId(userInfo, env);
                    return 'Please contact <a target="_blank" href="https://success.ringcentral.com/RCContactSupp">' +
                        'Customer Support</a> to enable ' + brandMap[brandId].brandName + ' brand in order to install the bot.';
                }

                function popupErrorMsg(msg, removeTitle) {
                    var modal = RCDPW.modal && RCDPW.modal.create().content(msg);
                    if (removeTitle) {
                        modal.removeTitle();
                    }
                    modal.show();
                }

                function getBrandId(userInfo, env) {
                    var brandId = _.get(userInfo, 'brand.id');
                    if (env !== prodKey && userInfo.isPartner) {
                        brandId = '1210';
                    }
                    return brandId;
                }
            }])
        .factory('dpwRoutes', [function () {
            return routes;
        }]);

    //TODO refactor filters move to ngFilter
    RCDPW.Angular.buildModule('filters')
        .filter('appStatus', [function () {
            return function (status) {
                return status;
            };
        }])
        .filter('keyStatus', ['keyStatusAlias', function (keyStatusAlias) {
            return function (status) {
                return keyStatusAlias[status] || status;
            };
        }]);

    RCDPW.Angular.buildModule('directives'
    ).directive('dpwMyAccount', [function () {
        return {
            restrict: 'A',
            scope: true,
            controller: [
                '$q', '$scope', 'api', '$route', '$routeParams', 'helpers', '$window', 'user',
                'myAccountNav', 'popup', '$location', 'popupUtil', 'dpwStorage', 'myAccountUtils',
                'trackUtil', 'mixpanelService', 'dpwBreadCrumbService', 'organizationService',
                function ($q, $scope, api, $route, $routeParams, helpers, $window, user, myAccountNav, popup, $location,
                    popupUtil, dpwStorage, myAccountUtils, trackUtil,
                    mixpanelService, dpwBreadCrumbService, organizationService) {
                    var self = this;
                    self.accountMenuGroups = [];
                    self.mixpanelService = mixpanelService;

                    self.logFreeTierUpgrade = function () {
                        trackUtil.logPageView('FreeTier:Upgrade');
                    };

                    myAccountUtils.getDevelopers({
                        onSuccess: function (data) {
                            $scope.profile = data;
                        }
                    });

                    $scope.$on('$routeChangeSuccess', function ($event, routeCurrent, routePrevious) {
                        var route = $route.current;
                        self.hideLeftMenu = route.hideLeftMenu === true;
                        self.hideHelpLink = route.hideHelpLink;
                        self.hideBreadCrumb = route.hideBreadCrumb;

                        route.noTitle && (self.panelTitle = '');
                        route.noNav && (self.accountMenuGroups = []); //avoid dazzle
                        self.breadCrumbItems = [];

                        var isAccountMenuTypeChanged = !routePrevious || routePrevious.menuType !== routeCurrent.menuType;

                        if (isAccountMenuTypeChanged) {
                            self.accountMenuGroups = myAccountNav.resolve(route, {
                                routeParams: $routeParams
                            });
                        } else {
                            myAccountNav.active(route, self.accountMenuGroups);
                        }

                        self.shouldAutoScroll = route.autoScroll !== false;

                        if (route.logPageViewTitle) {
                            trackUtil.logPageView(route.logPageViewTitle);
                            mixpanelService.trackPageView(route.logPageViewTitle);
                        }
                    });

                    $scope.$on('updateAppNav', function (event, application) {
                        $q.all([
                            organizationService.isApiCallHistoryEnabled(),
                        ]).then(function (res) {
                            self.accountMenuGroups = myAccountNav.resolve($route.current, {
                                application: application,
                                isApiCallHistoryEnabled: res[0]
                            });
                        });


                        self.breadCrumbItems = dpwBreadCrumbService.buildAppNav(_.get(application, 'name', ''));
                    });

                    $scope.$on('UserProfile:Enter', function () {
                        self.breadCrumbItems = dpwBreadCrumbService.buildProfileNav();

                    });

                    self.goBack = function () {
                        $window.history.go(-1);
                    };
                    self.buildHref = function (page, id) {
                        var route = routes[page] || {};
                        var rawPath = route.path;
                        var path = id ? rawPath.replace(':id', id) : rawPath;
                        if (page === 'developerProfile' && id === _.result($scope, 'profile.developer.id', '')) {
                            path = routes.myProfile.path;
                        }
                        return '/my-account.html#' + path;
                    };

                    self.buildAngularAppUrl = function (appId, pageName) {
                        return helpers.buildAngularAppUrl(appId, pageName);
                    }
                }],
            controllerAs: 'myAccountCtrl',
            templateUrl: 'myAccount.html'
        };
    }]
    ).directive('dpwLeaveComment', [function () {
        return {
            restrict: 'A',
            scope: true,
            controller: ['$scope', function ($scope) {
                var self = this;
                var popupConfig = $scope.popupConfig;
                self.actionBtnDisabled = function () {
                    return (popupConfig.commentRequired && _.size(self.comment) == 0);
                };
                self.actionHandler = function () {
                    if (self.actionBtnDisabled()) {
                        return;
                    }
                    popupConfig.onAction(self.comment);
                };
            }],
            controllerAs: 'ctrl',
            templateUrl: 'myAccount-leave-comment.html'
        };
    }]
    ).directive('dpwAppDashboardReports', [function () {
        return {
            restrict: 'A',
            scope: true,
            controller: ['$scope', '$routeParams', 'REPORTS',
                function ($scope, $routeParams, REPORTS) {
                    REPORTS.AppDashboardReportsController($scope, $routeParams, this);
                }
            ],
            controllerAs: 'ctrl',
            templateUrl: 'dpw-app-dashboard-reports.html'
        };
    }]
    ).directive('dpwCloneAppPopup', [function () {
        return {
            restrict: 'A',
            controller: ['$scope', function ($scope) {
                var self = this;
                var app = $scope.app;
                self.appName = ('[CLONE] ' + app.name).substr(0, 64);
                var config = $scope.config;

                self.cloneApp = function () {
                    config.onSubmit(self.appName);
                };
                $scope.$watch('ctrl.appName', function () {
                    config.onAppNameChanged();
                });
                self.close = function () {
                    config.onClose();
                };
            }],
            controllerAs: 'ctrl',
            templateUrl: 'dpw-clone-app-popup.html'
        };
    }]
    ).directive('dpwCloneAppCongrats', [function () {
        return {
            restrict: 'A',
            scope: true,
            templateUrl: 'dpw-clone-app-congrats.html',
            controllerAs: 'ctrl',
            controller: ['$scope', function ($scope) {
                this.close = function () {
                    $scope.configs.onClose();
                };
                this.isProfileOnly = $scope.configs.isProfileOnly;
                this.credentialsUrl = $scope.configs.credentialsUrl;
            }]
        };
    }]
    ).directive('dpwBotAccessTokenPopUp', function () {
        return {
            restrict: 'A',
            scope: true,
            templateUrl: 'dpw-bot-access-token-popup.html',
            controllerAs: 'ctrl',
            controller: ['$scope', function ($scope) {
                var self = this;
                var config = $scope.config;

                self.accessToken = config.accessToken;

                self.close = function () {
                    config.onClose();
                };
            }]
        };
    }
    ).directive('dpwBotInstallationConfirmation', [function () {
        return {
            restrict: 'A',
            scope: true,
            templateUrl: 'dpw-bot-installation-confirmation.html',
            controllerAs: 'ctrl',
            controller: ['$scope', 'botNameConfigurationService', function ($scope, botNameConfigurationService) {
                var self = this;
                var config = $scope.config;

                var defaultImg = '/assets/images/default_bot_image.svg';

                self.appIconUrl = config.appIconUrl || defaultImg;
                self.appName = config.app.name;
                self.permissions = config.permissions;
                self.botNameRegex = botNameConfigurationService.botNameRegex;
                self.isBotNameDisabled = true;

                botNameConfigurationService.get(config.app.id)
                    .then(function (data) {
                        var botNameFromApp = config.app.displayName || config.app.name || '';
                        self.botName = data.botNameInfo.botName || botNameFromApp.substring(0, 32);
                        self.isBotNameDisabled = data.botNameInfo.disallow;
                        self.botNameOccupiedMsg = self.isBotNameDisabled
                            ? RCDPW.Lang.MyAccount.DISABLE_BOT_NAME_INSTALL_OCCUPIED
                            : RCDPW.Lang.MyAccount.BOT_NAME_INSTALL_OCCUPIED;
                        self.botNameInvalidMsg = RCDPW.Lang.MyAccount.BOT_NAME_INVALID;
                    });

                self.showInputError = function (installBotForm) {
                    return !self.isBotNameDisabled && (installBotForm.botName.$invalid || self.showOccupiedError(installBotForm));
                };

                self.showOccupiedError = function (installBotForm) {
                    return !installBotForm.$dirty && self.botNameOccupied;
                };

                self.close = function () {
                    config.onClose();
                };

                self.submit = function (installForm) {
                    if (config.appKey && installForm.botName.$valid) {
                        config.onSubmit(config.appKey.id, self.botName, this);
                    }
                    installForm.$setPristine();
                };
            }]
        };
    }]
    ).directive('dpwBotRemovePopup', [function () {
        return {
            restrict: 'A',
            scope: true,
            templateUrl: 'dpw-bot-remove-popup.html',
            controllerAs: 'ctrl',
            controller: ['$scope', function ($scope) {
                var config = $scope.config;

                var envs = {
                    'prod': 'production environment'
                };

                this.env = envs[config.env];
                this.close = function () {
                    config.onClose();
                };

                this.submit = function () {
                    if (config.appKey) {
                        config.onSubmit(config.appKey.id);
                    }
                };
            }]
        };
    }]);

    RCDPW.Angular.buildModule('components')
        .component('dpwBannerArea', {
            templateUrl: 'dpw-banner-area.html',
            controller: [function () {
                var $ctrl = this;

                $ctrl.close = function () {
                    $ctrl.isHidden = true;
                    $ctrl.onClose();
                };
            }],
            bindings: {
                content: '<',
                onClose: '&'
            }
        });

    RCDPW.Angular.buildModule('controllers').controller(routes.appsList.controller,
        ['$scope', '$location', '$window', 'api', 'paging', 'helpers', '$route', 'popup', 'trackUtil', 'popupUtil',
            'dpwAccessService', 'myAcctAppsLinkStorage', 'applicationService', 'organizationService',
            function ($scope, $location, $window, api, paging, helpers, $route, popup, trackUtil, popupUtil,
                dpwAccessService, myAcctAppsLinkStorage, applicationService, organizationService) {
                var self = this;
                self.criteria = {
                    sortObj: {
                        name: true
                    }
                };
                // the api only support sort by name or date
                self.sortByList = ['name', 'date'];
                self.sort = function (keyName, isAsc) {
                    helpers.singleFieldSort(self.criteria.sortObj, keyName, isAsc);
                    updateApps();
                };
                self.getColorClassByAppStatus = function (app) {
                    return helpers.appStateUtil.getColorClassByAppStatus({
                        data: app,
                        isAdminSite: false
                    });
                };
                self.getAppStatusShortName = function (app) {
                    return helpers.appStateUtil.getStatusShortName(app);
                };

                self.isSampleApp = function (app) {
                    return app.id === self.sampleAppId;
                }

                self.getCreatedBy = function (app) {
                    if (!app.createdBy || app.createdBy === '<Deleted> <Deleted>') {
                        return 'Deleted user';
                    }

                    return app.createdBy;
                };

                self.isProfileOnly = applicationService.isProfileOnly;

                self.buildAppUrl = function (app) {
                    if (self.isProfileOnly(app)) {
                        return 'console/application/' + app.id + '/settings';
                    } else {
                        return $scope.myAccountCtrl.buildHref('appDashboard', app.id);
                    }
                };

                var pagingHandler = paging.init($scope, updateApps);
                var redirectPath = $location.search()['redirect-path'];

                function updateApps() {
                    var page = pagingHandler.getPaging().page;
                    var sortCondition = getSortCondition();
                    var statusParams = {
                        page: page > 1 ? page : null,
                        sortBy: sortCondition.sortBy !== self.sortByList[0] ? sortCondition.sortBy : null,
                        sortOrder: sortCondition.sortOrder !== 'asc' ? sortCondition.sortOrder : null
                    };
                    $route.updateParams(statusParams);
                }

                function getSortCondition() {
                    var sortBy = [];
                    var sortOrder = [];
                    angular.forEach(self.criteria.sortObj, function (value, key) {
                        // value is null or value is undefined
                        if (value == null) {
                            return;
                        }
                        sortBy.push(key);
                        sortOrder.push(value ? 'asc' : 'desc');
                    });
                    return {
                        sortBy: sortBy.join(','),
                        sortOrder: sortOrder.join(',')
                    };
                }

                $scope.$on('$routeChangeSuccess', function () {
                    updateAppsStatusFromUrl();
                    render();
                });

                function updateAppsStatusFromUrl() {
                    var routeCurrent = $route.current;
                    if (routeCurrent && routeCurrent.params) {
                        var status = {
                            page: null,
                            sortBy: self.sortByList[0],
                            sortOrder: 'asc'
                        };
                        var page = routeCurrent.params.page;
                        if (page) {
                            var pageNum = Number(page);
                            pagingHandler.getPaging().page = (_.isNaN(pageNum) || pageNum < 1) ? 1 : pageNum;
                            status.page = pagingHandler.getPaging().page;
                        }

                        // default sortBy is name,asc
                        var sortObj = {
                            name: true
                        };
                        var sortBy = routeCurrent.params.sortBy;
                        // the sortBy should is one of the sortByList
                        if (sortBy && self.sortByList.indexOf(sortBy) !== -1) {
                            sortObj = {};
                            sortObj[sortBy] = true;
                            status.sortBy = sortBy;
                        }
                        var sortOrder = routeCurrent.params.sortOrder;
                        // the default is asc(true), so when the sortOrder is desc, set the value be false
                        if (sortOrder && sortOrder === 'desc') {
                            angular.forEach(sortObj, function (value, key) {
                                sortObj[key] = false;
                            });
                            status.sortOrder = 'desc';
                        }
                        self.criteria.sortObj = sortObj;

                        saveAppsLinkToStorage(status);
                    }
                }

                function saveAppsLinkToStorage(status) {
                    // the data will be got in "WEB/common/assets/js/components/bread-crumb/dpw-bread-crumb.service.js"
                    // and "WEB_NEXT/projects/developer/src/app/console/application/breadcrumb/breadcrumb.component.ts"
                    var appsLink = getAppsLinkString(status);
                    sessionStorage.setItem(myAcctAppsLinkStorage, appsLink);
                }

                function getAppsLinkString(status) {
                    var appsLink = '/my-account.html#/applications';
                    var firstParam = true;
                    if (!status) {
                        return null;
                    }
                    if (status.page > 1) {
                        appsLink += '?page=' + status.page;
                        firstParam = false;
                    }
                    if (status.sortBy
                        // sortBy should is one of the sortByList
                        && self.sortByList.indexOf(status.sortBy) !== -1
                        // if sortBy is name, not need to put in the URL
                        && status.sortBy !== self.sortByList[0]) {
                        var sortByStr = getParamConnectionSymbol();
                        sortByStr += 'sortBy=' + status.sortBy;
                        appsLink += sortByStr;
                    }
                    // the sortOrder default is asc,and only when it is desc, put in the url
                    if (status.sortOrder && status.sortOrder === 'desc') {
                        var sortOrderStr = getParamConnectionSymbol();
                        sortOrderStr += 'sortOrder=' + status.sortOrder;
                        appsLink += sortOrderStr;
                    }
                    return appsLink;

                    function getParamConnectionSymbol() {
                        var symbol = '&';
                        if (firstParam) {
                            symbol = '?';
                            firstParam = false;
                        }
                        return symbol;
                    }
                }

                function render() {
                    api.call(api.myAccount.applications.list(self.criteria, pagingHandler.getPaging()), function (data) {
                        _.each(data.applications, getStatusIcon);
                        _.each(data.applications, updateDeletionStatus);
                        $scope.apps = data.applications || [];
                        if ($scope.apps.length === 0) {
                            self.noAppInfo = 'No Apps.';
                        }
                        pagingHandler.reset(data);
                        if ($scope.myAccountCtrl.isCreateApp) {
                            $scope.myAccountCtrl.isCreateApp = false;
                            self.openCreateApp();
                        }
                    });
                }

                organizationService.getOrganization().then(function (organization) {
                    self.orgName = organization.name;
                });

                applicationService.fetchSampleApp().then(function (data) {
                    self.sampleAppId = _.get(data, 'applicationId');
                });

                self.isBlocked = function (app) {
                    return app.appState.status === 'Blocked';
                }

                self.isSuspended = function (app) {
                    return app.appState.status === 'Suspended';
                }

                self.startCreateApp = function () {
                    sessionStorage.removeItem(myAcctAppsLinkStorage);
                    $window.location.href = RCDPW.entries.createApp.href;
                };

                self.openCreateApp = function () {
                    var newScope = $scope.$new();
                    newScope.wizardConfig = {
                        showOrgName: _.size($scope.apps) === 0,
                        typePlatformEditable: true,
                        previewAuthFlow: true,
                        title: 'Register App',
                        submitBtnText: 'Create',
                        isCreateApp: true,
                        onClose: function () {
                            newScope.$destroy();
                            redirectPath && $location.path(redirectPath).search('redirect-path', null).replace();
                        },
                        onSubmit: function (application, redirectUriHandler) {
                            application.organizationName = application.organization.name;
                            api.call(api.myAccount.applications.add({
                                data: helpers.appDataFilter(application)
                            }), function (data) {
                                newScope.$destroy();
                            }, function (data, defaultErrorHandler) {
                                if (_.get(data, 'status.message') === 'APP_NAME_UNAVAILABLE') {
                                    popupUtil.ok({
                                        content: RCDPW.Lang.MyAccount.APP_NAME_UNAVAILABLE,
                                        extraClasses: ['my-account']
                                    });
                                    return;
                                }
                                redirectUriHandler(data, defaultErrorHandler);
                            });
                        }
                    };
                    trackUtil.logPageView('CreateApp');
                    popup({
                        scope: newScope,
                        directiveName: 'dpw-app-wizard',
                        showHeader: 'false',
                        extraClass: 'popup-auto-width console-ui my-account popup-absolute'
                    });
                };
                self.showDeleteIcon = function (app) {
                    return _.includes(['Initial', 'Declined', 'Suspended'], app.appState.status) && !self.isSampleApp(app);
                };
                self.openDeleteApp = function (app) {
                    validateThenPopup();

                    function validateThenPopup() {
                        if (_.includes(['Public', 'Internal'], app.scope)) {
                            api.call(api.myAccount.applications.hasGraduatedProfiles(app.id), function (data) {
                                if (data.result) {
                                    RCDPW.modal && RCDPW.modal
                                        .create()
                                        .content(RCDPW.Lang.DELETE_APP.HAS_PUBLISHED_APP_PROFILE)
                                        .show();
                                    return;
                                }
                                popupConfirmationWindow();
                            });
                        } else {
                            popupConfirmationWindow();
                        }
                    }

                    function popupConfirmationWindow() {
                        popupUtil.confirm({
                            content: 'Are you sure you want to delete <span class="break-word">' + _.escape(app.name) + '</span>?',
                            buttons: [
                                {
                                    label: 'Cancel',
                                    style: 'button-with-border',
                                    action: 'close'
                                },
                                {
                                    label: 'Delete',
                                    style: 'button-orange',
                                    action: function () {
                                        api.call(api.myAccount.applications.updateStatus({
                                            applicationId: app.id,
                                            data: {
                                                oldStateStatus: helpers.appStateUtil.getStatus(app),
                                                appStateStatus: 'Deleted'
                                            }
                                        }), function () {
                                            popupCongrats();
                                            render();
                                        }, function (data, defaultErrorHandler) {
                                            defaultErrorHandler();
                                            render();
                                        });
                                    }
                                }
                            ]
                        });
                    }

                    function popupCongrats() {
                        popupUtil.ok({
                            title: ' ',
                            content: '<span class="break-word">' + _.escape(app.name) + '</span> has been deleted successfully!'
                        });
                    }
                };
                self.openCloneApp = function (app) {
                    var newScope = $scope.$new();
                    newScope.app = app;
                    newScope.errorsInfo = {
                        appNameAvailability: {
                            message: RCDPW.Lang.MyAccount.APP_NAME_UNAVAILABLE,
                            show: false
                        }
                    };

                    function switchOnError(keyName, switchOn) {
                        var errInfo = _.get(newScope.errorsInfo, keyName);
                        errInfo.show = !!switchOn;
                    }

                    newScope.config = {
                        onAppNameChanged: function () {
                            switchOnError('appNameAvailability', false);
                        },
                        onClose: function () {
                            newScope.$destroy();
                        },
                        onSubmit: function (appName) {
                            if (appName) {
                                switchOnError('appNameAvailability', false);
                                api.call(api.myAccount.applications.clone({
                                    applicationId: app.id,
                                    data: {
                                        name: appName
                                    }
                                }), function (data) {
                                    render();
                                    newScope.$destroy();
                                    newScope = $scope.$new();
                                    newScope.configs = {
                                        isProfileOnly: applicationService.isProfileOnly(app),
                                        credentialsUrl: helpers.buildAngularAppUrl(data.application.id, 'credentials'),
                                        onClose: function () {
                                            newScope.$destroy();
                                        }
                                    };

                                    popupCongrats();

                                    dpwAccessService.invalidateCache();

                                    function popupCongrats() {
                                        popup({
                                            scope: newScope,
                                            directiveName: 'dpw-clone-app-congrats',
                                            showHeader: 'false',
                                            extraClass: 'popup-auto-width console-ui my-account popup-absolute'
                                        });
                                    }
                                }, function (data, defaultErrorHandler) {
                                    if (data.status.message === 'ReachAppMaxAmount') {
                                        RCDPW.modal && RCDPW.modal
                                            .create()
                                            .content('Sorry! Your organization has reached the maximum limit of applications.')
                                            .show();
                                        newScope.config.onClose();
                                    } else if (data.status.message === 'APP_NAME_UNAVAILABLE') {
                                        switchOnError('appNameAvailability', true);
                                    } else {
                                        defaultErrorHandler();
                                    }
                                });
                            }
                        }
                    };
                    trackUtil.logPageView('CloneApp');
                    popup({
                        scope: newScope,
                        directiveName: 'dpw-clone-app-popup',
                        showHeader: 'false',
                        extraClass: 'popup-auto-width console-ui my-account popup-absolute'
                    });
                };

                dpwAccessService.currentUserCan(dpwAccessService.UserAction.CREATE_APP).then(function () {
                    self.canCreateApp = true;
                });

                dpwAccessService.currentUserCan(dpwAccessService.UserAction.CLONE_APP).then(function () {
                    self.canCloneApp = true;
                });

                dpwAccessService.currentUserCan(dpwAccessService.UserAction.SEE_ACTIONS_FOR_APPS).then(function () {
                    self.canSeeActionColumn = true;
                });

                function getStatusIcon(app) {
                    if (applicationService.isProfileOnly(app)) {
                        return null;
                    }

                    var appStatus = helpers.appStateUtil.getStatus(app);
                    var tooltips = {
                        blocked: 'Your app had been blocked in production',
                        declined: 'Your graduation request had been declined'
                    };
                    var displayIcon = _.includes(['Blocked', 'Declined'], appStatus);


                    app.statusIcon = displayIcon ? {
                        name: 'icon-icon_triangle_exclamation',
                        tooltip: tooltips[appStatus.toLowerCase()]
                    } : null;
                }

                function updateDeletionStatus(app) {
                    dpwAccessService.canManipulateApp(app.id).then(function () {
                        app.currentUserCanDelete = true;
                    });
                }
            }]
    ).controller(routes.createApp.controller, [
        '$scope', '$location',
        function ($scope, $location) {
            $scope.myAccountCtrl.isCreateApp = true;
            $location.path(routes.appsList.path);
        }
    ]
    ).controller(routes.appCreated.controller, [
        '$scope', '$location',
        function ($scope, $location) {
            var redirectPath = $location.search()['redirect-path'];
            $location.path(routes.appsList.path).search('redirect-path', redirectPath).replace();
        }
    ]
    ).controller(routes.appDashboard.controller,
        ['$scope', '$location', '$routeParams', '$sce', 'api', 'helpers', 'appInfo', 'clientInfo',
            'freeTierService', 'user', 'dpwAccessService', 'myAccountNav', 'applicationService', 'popup', 'popupUtil',
            'organizationService',
            function ($scope, $location, $routeParams, $sce, api, helpers, appInfo, clientInfo, freeTierService,
                user, dpwAccessService, myAccountNav, applicationService, popup, popupUtil, organizationService) {
                var self = this;
                self.hiddenFieldMsg = RCDPW.Lang.MyAccount.RolePermission.HIDDEN_FIELD;
                var appId = $routeParams.id;
                self.credentials = {};
                var forceRetrieve = false;

                var refreshAppFn = appInfo.fetch({
                    id: appId,
                    scope: $scope,
                    simple: false,
                    ctrlObj: self,
                    installCredentials: true,
                    callback: callback
                });
                $scope.$on('dpwDeveloperJourney:appStateUpdated', function (event, options) {
                    reRender(options);
                });
                self.requirementsProps = {};
                self.getAPIUrl = function () {
                    return _.compact(['https://platform', (self.showProdCredentials ? '' : 'devtest'), 'ringcentral.com']).join('.');
                };

                self.getCredentialsUrl = function () {
                    return helpers.buildAngularAppUrl(appId, 'credentials');
                };

                clientInfo.getProdServiceWebUrl().then(function (url) {
                    self.prodServiceWebUrl = helpers.onlinePortalLinks.prod(url);
                });

                clientInfo.getProdResetPasswordUrl().then(function (url) {
                    self.prodResetPasswordUrl = url;
                });

                self.getPortalUrl = function () {
                    if (self.showProdCredentials) {
                        return self.prodServiceWebUrl;
                    }
                };

                self.getTitle = function () {
                    return 'Credentials';
                };

                user.fetch().then(function () {
                    self.isFreeAccount = freeTierService.isFreeAccount(user.getUser());
                });

                self.isSampleApp = function () {
                    var attributes = _.get($scope.application, 'attributes', []);
                    var item = _.find(attributes, { id: 'QuickStartApp' });
                    return _.get(item, 'value') === 'true';
                }

                self.hasPermissionToViewAppSecret = function () {
                    var isViewingSampleAppSecretWithPermission = self.isSampleApp() && self.canViewSampleAppSecret;
                    return self.canManipulateApp || isViewingSampleAppSecretWithPermission;
                }

                function fetchRequirementsStatus(appId, retrieve) {
                    api.call(api.myAccount.appStatsDashboard({
                        applicationId: appId,
                        retrieve: !!retrieve,
                        noLoading: true
                    }), function updateRequirementsUI(response) {
                        self.requirementsProps.requirements = response;
                        self.requirementsProps.error = false;
                    }, function onError() {
                        self.requirementsProps.requirements = {};
                        self.requirementsProps.error = true;
                    });
                }

                function reRender(options) {
                    forceRetrieve = _.get(options, 'retrieve', false);
                    refreshAppFn();
                }

                function callback() {
                    if (myAccountNav.redirectToSettingsIfNeeded($scope.application)) {
                        return;
                    }
                    $scope.$emit('updateAppNav', $scope.application);
                    var status = helpers.appStateUtil.getStatus($scope.application);
                    self.showProdCredentials = _.includes(['Active', 'Suspended', 'Unblocking', 'Blocked'], status);
                    self.credentials.selectedKey = _.get(self, 'selectedProdKey');
                    self.credentials.keys = _.get(self, 'prodKeys');
                    helpers.appStateUtil.isInDev($scope.application) && fetchRequirementsStatus(appId, forceRetrieve);
                    forceRetrieve = false;

                    dpwAccessService.canManipulateApp($scope.application.id).then(function () {
                        self.canManipulateApp = true;
                    });

                    dpwAccessService.currentUserCan(dpwAccessService.UserAction.VIEW_SAMPLE_APP_SECRET).then(function () {
                        self.canViewSampleAppSecret = true;
                    });
                }

                self.isNotificationApp = function () {
                    return $scope.application && applicationService.isNotificationApp($scope.application)
                };

                self.isBotApp = function () {
                    return $scope.application && applicationService.isBotApp($scope.application);
                };

                self.isBlockedApp = function () {
                    return helpers.appStateUtil.getStatus($scope.application) === 'Blocked';
                };

                self.isSuspendedApp = function () {
                    return helpers.appStateUtil.getStatus($scope.application) === 'Suspended';
                };

                self.isActiveApp = function () {
                    return helpers.appStateUtil.getStatus($scope.application) === 'Active';
                };

                self.showUpdateAppStatusPopup = function (newStatus) {
                    var popupConfigMapping = {
                        'Active': {
                            actionLabel: 'Activate',
                            descHtml: 'Once you activate your app, users will be able to use it again <br>(no extra review needed)'
                        },
                        'Suspended': {
                            actionLabel: 'Suspend',
                            descHtml: 'Users will not have access to your app until you activate it again<br> (no extra review needed)'
                        }
                    };
                    var newScope = $scope.$new();
                    var config = popupConfigMapping[newStatus] || {};
                    newScope.popupConfig = {
                        getTitle: function () {
                            return [config.actionLabel, $scope.application.name].join(' ') + '?';
                        },
                        text: $sce.trustAsHtml(config.descHtml),
                        onClose: function () {
                            newScope.$destroy();
                        },
                        onAction: function (comment) {
                            api.call(api.myAccount.applications.updateStatus({
                                applicationId: $scope.application.id,
                                data: {
                                    oldStateStatus: helpers.appStateUtil.getStatus($scope.application),
                                    appStateStatus: newStatus,
                                    comment: comment
                                }
                            }), function () {
                                onActionComplete();
                            }, function (data, defaultErrorHandler) {
                                onActionComplete();
                                if (helpers.resUtil.isForbidden(data)) {
                                    popupStateChanged();
                                } else {
                                    defaultErrorHandler();
                                }
                            });
                        },
                        actionBtnName: config.actionLabel
                    };

                    popup({
                        scope: newScope,
                        directiveName: 'dpw-leave-comment',
                        extraClass: 'my-account popup-absolute my-account-leave-comment-popup'
                    });

                    function onActionComplete() {
                        newScope && newScope.$destroy();
                        $scope.$emit('dpwDeveloperJourney:appStateUpdated', {})
                    }

                    function popupStateChanged(callback) {
                        popupUtil.ok({
                            content: RCDPW.Lang.MyAccount.INVALID_ACTION,
                            extraClasses: ['my-account'],
                            showCloseBtn: false,
                            callback: function () {
                                callback && callback();
                            }
                        });
                    }
                };
            }
        ]
    ).controller(routes.reports.controller, [
        '$scope', '$routeParams', '$location', 'api', 'REPORTS', 'myAccountNav',
        function ($scope, $routeParams, $location, api, REPORTS, myAccountNav) {
            return new REPORTS.Controller($scope, $routeParams, $location, api.myAccount.applications.detail,
                myAccountNav.redirectToSettingsIfNeeded);
        }
    ]
    ).controller(routes.myProfile.controller, [
        '$scope', 'api', '$location', 'user', 'helpers', 'freeTierService', 'myAccountUtils', '$filter',
        function ($scope, api, $location, user, helpers, freeTierService, myAccountUtils, $filter) {
            var userInfo = {};

            user.fetch().then(function () {
                userInfo = user.getUser();

                myAccountUtils.getDevelopers({
                    onSuccess: function (data) {
                        $scope.profileInfo = data;
                    }
                });
            });

            this.isUsingFreeAccount = function () {
                return freeTierService.isFreeAccount(userInfo);
            };

            this.redirectToEditProfile = function () {
                $location.path(routes.editProfile.path);
            };

            this.isValidTime = function (time) {
                return $filter('ignoreInvalidTime')(time);
            };

            $scope.$emit('UserProfile:Enter');
        }]
    ).controller(routes.org.controller, ['$scope', 'api', '$location', 'paging', 'popup', 'user', 'helpers',
        'popupUtil', 'partnerTypeLogos', 'dpwAccessService', 'manageRoleAndAppAccessService', 'dpwUserRoleService',
        'freeExtensionService', 'developerService', 'organizationService',
        function ($scope, api, $location, paging, popup, user, helpers, popupUtil, partnerTypeLogos,
            dpwAccessService, manageRoleAndAppAccessService, dpwUserRoleService, freeExtensionService,
            developerService, organizationService) {
            var self = this;

            self.messages = {
                NO_PERMISSION_TO_INVITE_NEW_DEVELOPER: RCDPW.Lang.MyAccount.RolePermission.NO_PERMISSION
            };

            self.hasPartnerLogo = false;
            renderOrgInfo();
            var pagingHandler = paging.init($scope, renderDevloperList);
            renderDevloperList();

            dpwAccessService.currentUserCan(dpwAccessService.UserAction.EDIT_ORG_NAME).then(function () {
                self.canEditOrgName = true;
            });

            dpwAccessService.currentUserCan(dpwAccessService.UserAction.INVITE_NEW_DEVELOPER).then(function () {
                self.canInviteNewDeveloper = true;
            });

            dpwAccessService.currentUserCan(dpwAccessService.UserAction.MANAGE_ROLE_AND_APP_ACCESS)
                .then(function () {
                    self.canManageRoleAndAppAccess = true;
                });

            dpwAccessService.currentUserCan(dpwAccessService.UserAction.MANAGE_DEVELOPER_LIST)
                .then(function () {
                    self.canManageDeveloperList = true;
                });

            self.manageRoleAndAppAccess = function (id) {
                manageRoleAndAppAccessService.showDialog(id);
            };

            self.getUserRoleLabel = function (userRoleId) {
                var userRole = dpwUserRoleService.getUserRoleById(userRoleId);
                return userRole.label;
            };

            self.inviteNewDeveloper = {
                isDisabled: function () {
                    return !self.canInviteNewDeveloper || self.freeExtMaxCountReached();
                },
                getDisabledMsg: function () {
                    if (!self.canInviteNewDeveloper) {
                        return RCDPW.Lang.MyAccount.RolePermission.NO_PERMISSION;
                    }

                    return RCDPW.textInterpolate(
                        'You are using a Free Developer Account which has a maximum of {{maxCount}}.',
                        { maxCount: self.freeExtMaxCount + (self.freeExtMaxCount === 1 ? ' developer' : ' developers') }
                    );
                }
            };

            self.freeExtMaxCountReached = function () {
                return _.size($scope.developers) >= self.freeExtMaxCount;
            };

            function renderDevloperList() {
                api.call(api.myAccount.developers.list(pagingHandler.getPaging()), function (data) {
                    pagingHandler.reset(data);

                    user.fetch().then(function () {
                        var userInfo = user.getUser();

                        $scope.developers = _.map(data.developers, function (dev) {
                            dev.canRemove = dev.rcExtensionId !== userInfo.accountId && dev.rcExtensionId !== userInfo.extensionId;
                            return dev;
                        });
                    });
                });

            }

            function renderOrgInfo() {
                organizationService.getOrganization().then(function (organization) {
                    $scope.organization = organization;
                    var type = _.get(organization, 'type');
                    self.isFreeOrg = type === 'Free';

                    if (self.isFreeOrg) {
                        freeExtensionService.loadMaxCount().then(function (maxCount) {
                            self.freeExtMaxCount = parseInt(maxCount);
                        });
                    }

                    if (helpers.partnerType.shouldShow($scope.organization)) {
                        api.call(api.myAccount.organizations.getPartnerType(), function (data) {
                            self.hasPartnerLogo = data.partnerBadgeType !== 'Blank';
                            self.partnerLogos = partnerTypeLogos[data.partnerBadgeType]
                                .map(function (logos) {
                                    return {
                                        logo: logos.logo,
                                        svg: helpers.addCacheBuster(logos.svg),
                                        png: helpers.addCacheBuster(logos.png)
                                    };
                                });
                        }, function () {
                            self.hasPartnerLogo = false;
                        });
                    }
                });
            }

            self.logoTarget = helpers.isSafari() ? '_self' : '_blank';

            self.editName = function () {
                var newScope = $scope.$new();
                newScope.orgInfo = {
                    name: $scope.organization.name
                };
                newScope.callback = callback;

                popup({
                    scope: newScope,
                    directiveName: 'dpw-edit-org-name-popup',
                    extraClass: 'console-ui my-account'
                });

                function callback() {
                    api.call(api.myAccount.organizations.update({ organizationName: newScope.orgInfo.name }), function (data) {
                        newScope.$destroy();
                        organizationService.clearOrgPromise();
                        renderOrgInfo();
                    });
                }
            };

            self.openDeleteDev = function (dev) {
                developerService.isPrimaryContact(dev.id).then(function (isPrimaryContact) {
                    if (isPrimaryContact) {
                        popupBlockDeleteDeveloper();
                    } else {
                        popupConfirmDeleteDeveloper(dev);
                    }
                });
            };

            self.openInviteUser = function () {
                var newScope = $scope.$new();
                newScope.config = {
                    close: function () {
                        newScope.$destroy();
                    }
                };

                popup({
                    scope: newScope,
                    directiveName: 'dpw-free-extension-invitation',
                    showHeader: false,
                    extraClass: 'console-ui my-account popup-auto-width'
                });
            };

            function popupBlockDeleteDeveloper() {
                popupUtil.ok({
                    title: 'Sorry',
                    content: 'You are unable to delete this user as they are listed as the ' +
                        'primary contact for one or more apps in your organization.'
                });
            }

            function popupConfirmDeleteDeveloper(dev) {
                var devName = _.escape([dev.firstName, dev.lastName].join(' '));
                popupUtil.confirm({
                    content: 'Are you sure you want to remove <span class="break-word">' + devName + '</span> from the organization?',
                    buttons: [
                        {
                            label: 'Cancel',
                            style: 'button-with-border',
                            action: 'close'
                        },
                        {
                            label: 'Remove',
                            style: 'button-orange',
                            action: function () {
                                api.call(api.myAccount.freeExtension.delete(dev.id), function () {
                                    popupRemoveSuccessfully(devName);
                                    renderDevloperList();
                                }, function (data, defaultErrorHandler) {
                                    defaultErrorHandler();
                                    renderDevloperList();
                                });
                            }
                        }
                    ]
                });
            }

            function popupRemoveSuccessfully(devName) {
                popupUtil.ok({
                    title: ' ',
                    content: '<span class="break-word">' + devName + '</span> has been removed successfully from the organization!'
                });
            }
        }
    ]
    ).controller(routes.developerProfile.controller, [
        '$scope', 'api', '$location', '$routeParams', 'myAccountUtils', '$filter',
        function ($scope, api, $location, $routeParams, myAccountUtils, $filter) {
            var developerId = $routeParams.id;
            myAccountUtils.getDevelopers({
                data: { id: developerId },
                onSuccess: function (data) {
                    $scope.profileInfo = data;
                }
            });

            this.isValidTime = function (time) {
                return $filter('ignoreInvalidTime')(time);
            };


            $scope.$emit('UserProfile:Enter');
        }]
    ).controller(routes.appUsagePlanDetails.controller, ['$scope', 'applicationService', '$routeParams', 'helpers', 'myAccountNav', '$q',
        function ($scope, applicationService, $routeParams, helpers, myAccountNav, $q) {
            var self = this;
            self.getApiRefUrl = helpers.getApiRefUrl;

            $q.all([
                applicationService.fetchApp($routeParams.id),
                applicationService.getAppUsagePlan($routeParams.id)
            ]).then(function (result) {
                var appInfo = result[0];
                var usagePlanLimits = result[1].limits;
                if (myAccountNav.redirectToSettingsIfNeeded(appInfo.application)) {
                    return;
                }

                $scope.$emit('updateAppNav', appInfo.application);
                self.orderedLimits = helpers.buildOrderedLimits(Object.keys(usagePlanLimits), usagePlanLimits);
                self.application = appInfo.application;
            });
        }]
    ).controller(routes.appStatusAndReview.controller, ['$window', '$location', '$routeParams', function ($window, $location, $routeParams) {
        var appId = $routeParams.id;
        $window.location.href = routes.appGraduation.path.replace(':id', appId);
    }]).controller(routes.appPublish.controller, ['$scope', '$routeParams', '$location', 'applicationService', 'appProfileUtils', 'myAccountNav', 'dpwAccessService',
        function ($scope, $routeParams, $location, applicationService, appProfileUtils, myAccountNav, dpwAccessService) {
            var self = this;

            self.extraClass = 'app-profile-detail-dev-middle-width';

            applicationService.fetchApp($routeParams.id)
                .then(function (data) {
                    if (!appProfileUtils.isAppPublishEnabled(data.application)) {
                        myAccountNav.redirectToDashboard($routeParams.id);
                        return;
                    }

                    $scope.$emit('updateAppNav', data.application);
                    self.application = data.application;
                    self.allDataReady = true;
                });

            dpwAccessService.canManipulateApp($routeParams.id).then(function () {
                self.canManipulateApp = true;
            });
        }]
    ).controller(routes.editProfile.controller, ['$scope', function ($scope) {
        $scope.$emit('UserProfile:Enter');
    }]
    ).controller(routes.apiQuickStart.controller, [function () {
        window.location.href = RCDPW.helloWorldUrl;
    }]
    ).controller(routes.setupWizard.controller, [function () {
        window.location.href = RCDPW.helloWorldUrl;
    }]).controller(routes.leadsReport.controller, [function () {
    }]
    ).config(['$routeProvider', 'pagingProvider', function ($routeProvider, pagingProvider) {
        _.forEach(routes, buildRouteConfig);
        $routeProvider.otherwise({
            redirectTo: routes.appsList.path
        });

        function buildRouteConfig(route) {
            if (!route.external && route.path) {
                $routeProvider.when(route.path, angular.extend({
                    templateUrl: 'myAccount-' + route.path.substr(1) + '.html',
                    controllerAs: 'ctrl'
                }, route));
            }
        }

        pagingProvider.setPerPage(20);
    }]
    );
})
    (RCDPW.moduleNames.MY_ACCOUNT);
